import { SET_CONTEXT, SYNC_CONTEXT } from 'b2b-apps/shop/context/redux/actionTypes';
import { ContextState, SetContextAction, SyncContextAction } from 'b2b-apps/shop/context/redux/types';

const setContext = (context: ContextState): SetContextAction => ({
  type: SET_CONTEXT,
  payload: {
    context,
  },
});

const syncContext = (): SyncContextAction => ({
  type: SYNC_CONTEXT,
});


export {
  setContext,
  syncContext,
};
